import { render, staticRenderFns } from "./CompensationBudgetItem.vue?vue&type=template&id=0b33f174&"
import script from "./CompensationBudgetItem.vue?vue&type=script&lang=js&"
export * from "./CompensationBudgetItem.vue?vue&type=script&lang=js&"
import style0 from "./CompensationBudgetItem.vue?vue&type=style&index=0&id=0b33f174&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports